import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MoveRight } from "lucide-react";
import { storageUnits } from "@/storage";

export function StoragePage() {
  return (
    <div data-testid="storage-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">The storage edit</span>
          <h1>Everything in its place,<br /><i>beautifully concealed.</i></h1>
          <p>Storage is the quiet architecture of a calm home. Our systems are composed in solid wood and figured veneer — built in our Vasai factory to hold your life gracefully, for decades.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start a conversation <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src={storageUnits[0].image} alt={storageUnits[0].alt} />
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">The collection</span>
          <h2>Six studies<br /><i>in quiet order.</i></h2>
          <div className="series-grid">
            {storageUnits.map((s) => (
              <Link to={`/storage/${s.slug}`} className="series-card" key={s.slug} data-testid={`storage-card-${s.index}`}>
                <img src={s.image} alt={s.alt} />
                <div>
                  <span>{s.index} / 06</span>
                  <h3>{s.name}</h3>
                  <p>{s.finish} · {s.layout}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export function StorageDetail() {
  const { slug } = useParams();
  const unit = storageUnits.find((s) => s.slug === slug);

  if (!unit) {
    return (
      <section className="kitchen-detail" data-testid="storage-not-found">
        <Link to="/storage" className="back-link" data-testid="back-to-collection-link">
          <ArrowLeft size={15} /> Back to the collection
        </Link>
        <h1 className="detail-missing">This piece is not in our collection.</h1>
      </section>
    );
  }

  return (
    <section className="kitchen-detail" data-testid="storage-detail-page">
      <Link to="/storage" className="back-link" data-testid="back-to-collection-link">
        <ArrowLeft size={15} /> Back to the collection
      </Link>
      <div className="detail-grid">
        <figure className="detail-image" data-testid="storage-detail-image">
          <img src={unit.image} alt={unit.alt} />
          <figcaption>{unit.index} / 06 — {unit.finish}</figcaption>
        </figure>
        <div className="detail-specs">
          <span className="eyebrow">Storage {unit.index} / 06</span>
          <h1 data-testid="storage-detail-title">{unit.name}</h1>
          <p className="detail-description" data-testid="storage-detail-description">{unit.description}</p>
          <dl className="spec-list" data-testid="storage-spec-list">
            <div className="spec-row" data-testid="spec-finish">
              <dt>Finish</dt>
              <dd>{unit.finish}</dd>
            </div>
            <div className="spec-row" data-testid="spec-layout">
              <dt>Layout</dt>
              <dd>{unit.layout}</dd>
            </div>
            <div className="spec-row" data-testid="spec-materials">
              <dt>Materials</dt>
              <dd>
                <ul>
                  {unit.materials.map((m) => <li key={m}>{m}</li>)}
                </ul>
              </dd>
            </div>
          </dl>
          <Link to="/contact" className="button" data-testid="storage-consultation-cta">
            Book a private consultation <MoveRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
}
